import { Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Subject } from 'rxjs';
import { startOfDay, isSameDay, isSameMonth, endOfDay } from 'date-fns';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarMonthViewDay } from 'angular-calendar';
import { FuseConfirmDialogComponent } from '../../../../@fuse/components/confirm-dialog/confirm-dialog.component';
import { fuseAnimations } from '@fuse/animations';
import { CalendarService } from './calendar.service';
import { CalendarEventModel } from './event.model';
import { CalendarEventFormDialogComponent } from './event-form/event-form.component';
import { Parse } from 'parse';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { DatePipe } from '@angular/common';
import { DataService } from 'app/shared/common/helper/http-service';
import { Configuration } from 'app/app.configuration';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute } from '@angular/router';
import { SocketService } from 'app/shared/common/helper/socket.service';

@Component({
    selector: 'calendar',
    templateUrl: './calendar.component.html',
    styleUrls: ['./calendar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class CalendarComponent implements OnInit {

    eventTypes: any[] = [
        { value: 'Leave', viewValue: 'Leave' },
        { value: 'Meeting', viewValue: 'Meeting' },
        { value: 'Task', viewValue: 'Task' },
    ];

    colors: any = {
        green: {
            primary: '#5bd963',
            secondary: '#FAE3E3'
        },
        blue: {
            primary: '#1e90ff',
            secondary: '#D1E8FF'
        },
        yellow: {
            primary: '#e3bc08',
            secondary: '#FDF1BA'
        },
        orange: {
            primary: '#F99417',
            secondary: '#F99417'
        }
    };

    actions: CalendarEventAction[];
    activeDayIsOpen: boolean;
    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
    @ViewChild('addTask', { static: true }) addTask: TemplateRef<any>;
    @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;
    dialogRef: any;
    events: CalendarEvent[];
    refresh: Subject<any> = new Subject();
    selectedDay: any;
    view: string;
    viewDate: Date;
    idLabels: string[];
    onEventsUpdated: Subject<any>;
    profileId = '';
    empRole = '';
    currentuser: any;
    eventType: any;
    eventTypeValue: string;
    totalAngularPackages: any;
    department = '';
    isShow: boolean = true;
    eventList: any;
    taskForm: FormGroup;
    currentDay: string;
    deleteRecursiveId: string = '';
    recursiveUniqueId: string = '';
    deleteRecursive: string = 'this';
    recursiveStartDeleteDate: any;
    projectInfo = [];
    tenantId: string = '';
    backlogBoardListId: any;
    getBacklogsSprintId: any;
    currentUser: any;
    todayDay = this.datePipe.transform(new Date(), 'EEEE');
    taskType: Array<string> = ["Does not repeat", "Daily", 'Weekdays', `Weekly on ${this.todayDay}`, `Monthly on the third ${this.todayDay}`, "Every weekday (Monday to Friday)"];
    scheduleType: string = 'Does not repeat';
    deleteTaskStatus: string = '';


    constructor(
        private _matDialog: MatDialog,
        private _calendarService: CalendarService,
        private parseService: ParseService,
        private toastr: ToastrService,
        private storageConfiguration: StorageConfiguration,
        private fb: FormBuilder,
        private dataService: DataService,
        private appConfiguration: Configuration,
        private spinner: NgxSpinnerService,
        private configuration: Configuration,
        private datePipe: DatePipe,
        private route: ActivatedRoute,
        private _socket: SocketService
    ) {
        this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
        this.currentUser = this.parseService.instance.User.current();
        this.onEventsUpdated = new Subject();
        // Set the defaults
        this.view = 'month';
        this.viewDate = new Date();
        this.activeDayIsOpen = true;
        this.selectedDay = { date: startOfDay(new Date()) };

        this.actions = [];
        this.currentuser = this.parseService.instance.User.current();
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.profileId = this.currentuser.get('profile').id;

        //  Get events from service/server
        this.setEvents();
        this._calendarService.getLeaveData().subscribe(result => {
            this.events = result.map(item => {
                return new CalendarEventModel(item);
            });
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    async ngOnInit(): Promise<void> {

        this.route.params.subscribe(param => {
            this.isShow = !param.isTaskCalendar;
            this.getTaskList();
        });

        this._socket.desktopTaskStatus.subscribe((event: any) => {
            this.toastr.info('Task status updated!!');
            this.getTaskList();
        });

        //  Watch re-render-refresh for updating db
        this.refresh.subscribe(updateDB => {
            if (updateDB) {
                this._calendarService.updateEvents(this.events);
            }
        });

        this._calendarService.onEventsUpdated.subscribe(events => {
            this.refresh.next();
        });

        let queryInstance = this.parseService.instance.Object.extend('Profile');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', this.profileId);
        query.include('department');
        let results = await query.find();
        let department = results[0].get('department');
        this.department = department.get('name');

        this.taskFrom();
        let datePipe = new DatePipe("en-US");
        this.currentDay = datePipe.transform(new Date(), "MM/dd/yyyy");
    }

    taskFrom() {
        this.taskForm = this.fb.group({
            title: ["", Validators.required],
            estimatedHours: [1, Validators.required],
            projectId: ["", Validators.required],
            startDate: [new Date(), Validators.required],
            endDate: [new Date(), Validators.required],
            priority: ["", Validators.required],
            scheduleType: ['']
        });
    }

    setEvents(): void {
        this.events = this._calendarService.events.map(item => {
            return new CalendarEventModel(item);
        });
    }

    /**
     * Before View Renderer
     *
     * @param {any} header
     * @param {any} body
     */
    beforeMonthViewRender({ header, body }): void {
        const _selectedDay = body.find((_day) => {
            return _day.date.getTime() === this.selectedDay.date.getTime();
        });

        if (_selectedDay) {
            /**
             * Set selected day style
             * @type {string}
             */
            _selectedDay.cssClass = 'cal-selected';
        }
    }

    selectedMonth(event) {
        this._calendarService.setAllEvents(event);
        if (event) this.getTaskList(event);
    }

    /**
     * Day clicked
     *
     * @param {MonthViewDay} day
     */
    dayClicked(day: CalendarMonthViewDay): void {
        const date: Date = day.date;
        const events: CalendarEvent[] = day.events;

        if (isSameMonth(date, this.viewDate)) {
            if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
                this.activeDayIsOpen = false;
            }
            else {
                this.activeDayIsOpen = true;
                this.viewDate = date;
            }
        }
        this.selectedDay = day;
        this.refresh.next();
    }

    /**
     * Event times changed
     * Event dropped or resized
     *
     * @param {CalendarEvent} event
     * @param {Date} newStart
     * @param {Date} newEnd
     */
    eventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent): void {
        event.start = newStart;
        event.end = newEnd;
        this.refresh.next(true);
    }

    /**
     * Delete Event
     *
     * @param event
     */
    deleteEvent(event): void {
        this.confirmDialogRef = this._matDialog.open(FuseConfirmDialogComponent, {
            disableClose: false
        });
        this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
        this.confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                const eventIndex = this.events.indexOf(event);
                let dbClass;
                let query;
                if (event.leaveId) {
                    dbClass = Parse.Object.extend('Leaves');
                    query = new Parse.Query(dbClass);
                    query.equalTo('objectId', event.leaveId);
                } else {
                    dbClass = Parse.Object.extend('Tasks');
                    query = new Parse.Query(dbClass);
                    query.equalTo('objectId', event.taskId);
                }
                query.find().then(leave => {
                    leave[0].destroy().then((object) => {
                        this.toastr.success('Record Deleted Successfully');
                        this.events.splice(eventIndex, 1);
                        this.refresh.next();
                    }, (error) => {

                    }).then().catch(error => {

                    });
                });
            }
            this.confirmDialogRef = null;
        });

    }

    /**
     * Edit Event
     *
     * @param {string} action
     * @param {CalendarEvents} event
     */
    editEvent(action: string, event: CalendarEvent): void {
        if (event.meta.notes != 'Holidays') {
            var eventIndex = this.events.indexOf(event);
            localStorage.setItem('eventIndex', eventIndex + '');

            this.dialogRef = this._matDialog.open(CalendarEventFormDialogComponent, {
                panelClass: 'event-form-dialog',
                data: {
                    event: event,
                    action: action
                },
              
            });
            this.dialogRef.componentInstance.event = event;
            this.dialogRef.afterClosed().subscribe(response => {
                if (!response) {
                    return;
                }
                const actionType: string = response[0];
                const formData: FormGroup = response[1];
                switch (actionType) {
                    case 'save':
                        this.events[eventIndex] = Object.assign(this.events[eventIndex], formData.getRawValue());
                        this.refresh.next(true);
                        break;
                    case 'delete':
                        this.deleteEvent(event);
                        break;
                }
            });
        }
    }

    /**
     * Add Event
     */
    addEvent(type): void {
        this.dialogRef = this._matDialog.open(CalendarEventFormDialogComponent, {
            panelClass: 'event-form-dialog',
            data: {
                action: 'new',
                date: this.selectedDay.date,
                type: type
            },
            disableClose:true
        });
        this.dialogRef.afterClosed().subscribe((response: FormGroup) => {
            if (!response) {
                return;
            }
            const newEvent = response.getRawValue();
            newEvent.actions = this.actions;
            this.events.push(newEvent);
            this.refresh.next(true);
        });
    }


    handleEvent(event: any) {
        console.log(event, "handleEvent");
    }

    addTaskEvent() {
        this._matDialog.open(this.addTask, {
            width: '610px',
            disableClose: false,
        });
    }

    getTaskList(date?: any) {
        this.spinner.show();
        let startEnd = this._calendarService.startenddates(date ? date : new Date());
        let queryInstance = this.parseService.instance.Object.extend('Tasks');
        let query = new this.parseService.instance.Query(queryInstance);
        query.containedIn("assigneesId", [this.parseService.instance.User.current().get('profile').id]);
        query.equalTo('isActive', true);
        query.greaterThan('startDate', startEnd[0]);
        query.lessThan('startDate', startEnd[1]);
        query.limit(10000);
        query.find().then(result => {
            if (result.length > 0) {
                this.eventList = [];
                for (let data of result) {
                    let taskStatus = data.get('userPlannedStatus');
                    var notYetStarted = '';
                    var completed = '';
                    var inProgress = '';
                    var hold = '';
                    if (taskStatus == 'new') notYetStarted = 'Not Yet Started';
                    else if (taskStatus == 'completed') completed = `<span class="far fa-check-circle completed-task"></span>`;
                    else if (taskStatus == 'in-progress') inProgress = `<span class="fas fa-history inprogress-task"></span>`;
                    else if (taskStatus == 'backlog') hold = `<span class="far fa-pause-circle hold-task"></span>`;

                    let event = {
                        id: data.id,
                        title: data.get('title'),
                        start: startOfDay(data.get('startDate')),
                        end: endOfDay(data.get('startDate')),
                        color: notYetStarted ? this.colors.blue : completed ? this.colors.green : inProgress ? this.colors.yellow : hold ? this.colors.orange : '',
                        actions: [
                            {
                                label: notYetStarted ? notYetStarted : completed ? completed : inProgress ? inProgress : hold ? hold : ''
                            },
                            {
                                label: `<span class="fas fa-trash-alt delete"></span>`,
                                onClick: ({ event }: { event: CalendarEvent }): void => {
                                    this.deleteRecursive = 'this';
                                    this.deleteRecursiveId = data.id;
                                    this.deleteTaskStatus = data.get('userPlannedStatus');
                                    this.recursiveUniqueId = data.get('recursiveKey');
                                    this.recursiveStartDeleteDate = data.get('startDate');
                                    this._matDialog.open(this.confirmPopup);
                                }
                            }
                        ],
                    }
                    this.eventList.push(event);
                }
            }
            this.spinner.hide();
        });
    }

    closePopup() {
        this._matDialog.closeAll();
    }

    deleteRecursiveTask() {

        if (this.deleteTaskStatus == 'in-progress' && this.datePipe.transform(new Date(), 'MMM d, y') == this.datePipe.transform(this.recursiveStartDeleteDate, 'MMM d, y')) {
            return this.toastr.warning('Tasks is in an "in-progress state." Please update the status to "hold" or "completed" in the desktop application. And then delete the task.')
        }
        this.spinner.show();
        let payload = { startDate: this.recursiveStartDeleteDate }
        let serviceUrl = `${this.appConfiguration.deleteRecursiveTask}/${this.deleteRecursiveId}?deleteType=${this.deleteRecursive}`
        if (this.deleteRecursive == 'thisAndFollowing' || this.deleteRecursive == 'all') serviceUrl = `${serviceUrl}&recursiveKey=${this.recursiveUniqueId}`
        this.dataService.delete(serviceUrl, payload).subscribe(async (data: any) => {
            if (data.isSuccess) {
                this.eventList = [];
                await this.getTaskList();
                this.toastr.success("Deleted successfully!!");
            }
            else this.toastr.warning("Something went wrong!!");
            this.spinner.hide();
        });
        this.spinner.hide();
    }


}


